import React from 'react';
import PropTypes from 'prop-types';
import { graphql, Link, useStaticQuery } from 'gatsby';
import { List } from '@pella/sash-framework';
import { isValidArray } from '../../../utilities/validations';

const ShowroomDirectory = ({ region }) => {
	const queryData = useStaticQuery(query);
	const newShowrooms = queryData.allContentstackBranchShowroom.nodes.map((showroom) => ({
		title: showroom.display_name,
		state: {
			state_name: showroom.state.state_name || showroom.state.province,
			canada: showroom.state.canada,
		},
		showroom_id: showroom.showroom_id,
		url: showroom.branch_data?.[0]?.state_url,
	}));

	const reducedStates = newShowrooms.filter((state, index, self) => self.findIndex((t) => t.state.state_name === state.state.state_name) === index);

	const sortArrayByStateName = (a, b) => a.state.state_name.localeCompare(b.state.state_name);

	const regionList = reducedStates.filter((country) => (region === 'usa' ? !country.state.canada : country.state.canada));

	if (!isValidArray(reducedStates)) return null;

	return (
		<List
			bullets='none'
			className={`md:columns-6 xl:columns-7 ${region === 'usa' ? 'columns-2' : 'columns-1'}`}
			data-testid='showroom-directory'
		>
			{isValidArray(regionList) &&
				regionList.sort(sortArrayByStateName).map((item, index) => (
					<React.Fragment key={index}>
						<li className='text-body-2 mb-6 whitespace-nowrap'>
							<Link to={item.url}>{item.state.state_name}</Link>
						</li>
						{region === 'canada' && index === 1 && (
							<li
								className='hidden md:block md:h-6'
								style={{ columnSpan: 'all' }}
							/>
						)}
					</React.Fragment>
				))}
		</List>
	);
};

ShowroomDirectory.propTypes = {
	region: PropTypes.string,
};

export default ShowroomDirectory;

export const query = graphql`
	{
		allContentstackBranchShowroom {
			nodes {
				url
				showroom_id
				display_name
				state {
					abbreviation
					state_name
					canada
					province
				}
				branch_data {
					state_url
				}
			}
		}
	}
`;
